import { NavLink } from "react-router-dom";

export default function NewsItemLanding({ article }) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <>
      <div className="flex flex-col items-start ">
        <NavLink
          to={`/news/` + article?.slug}
          className="relative w-full md:pt-0 pt-60 bg-no-repeat bg-center bg-cover md:bg-none"
          style={{
            backgroundImage: `url(${article?._embedded["wp:featuredmedia"][0]?.source_url})`,
          }}
        >
          <div className="overflow-hidden md:block hidden h-full">
            <img
              src={article?._embedded["wp:featuredmedia"][0]?.source_url}
              alt={article?.title?.rendered}
              className={` min-h-52 w-auto bg-gray-100 object-cover transition duration-700 ease-in-out transform hover:scale-110 h-60`}
            />
          </div>
        </NavLink>
        <div className="max-w-xl">
          <div className="relative">
            <div className="text-lg mt-4 mb-2 text-[#58b947] font-medium">
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    new Date(article.date).getDate() +
                    " " +
                    monthNames[new Date(article.date).getMonth()] +
                    " " +
                    new Date(article.date).getFullYear(),
                }}
              />
            </div>
            <h3 className="font-normal text-white text-2xl ">
              <NavLink to={`/news/` + article?.slug}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: article?.title?.rendered,
                  }}
                />
              </NavLink>
            </h3>
          </div>
        </div>
      </div>
    </>
  );
}
